/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWithoutNameProjection
 */
export interface UserWithoutNameProjection {
    /**
     * 
     * @type {number}
     * @memberof UserWithoutNameProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserWithoutNameProjection
     */
    email?: string;
    /**
     * 
     * @type {number}
     * @memberof UserWithoutNameProjection
     */
    partnerId: number;
}

/**
 * Check if a given object implements the UserWithoutNameProjection interface.
 */
export function instanceOfUserWithoutNameProjection(value: object): value is UserWithoutNameProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    return true;
}

export function UserWithoutNameProjectionFromJSON(json: any): UserWithoutNameProjection {
    return UserWithoutNameProjectionFromJSONTyped(json, false);
}

export function UserWithoutNameProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWithoutNameProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'partnerId': json['partner_id'],
    };
}

export function UserWithoutNameProjectionToJSON(json: any): UserWithoutNameProjection {
    return UserWithoutNameProjectionToJSONTyped(json, false);
}

export function UserWithoutNameProjectionToJSONTyped(value?: UserWithoutNameProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'partner_id': value['partnerId'],
    };
}

